import React from "react";
import { Boxes, Cpu, Workflow, Building2 } from "lucide-react";

const capabilities = [
  "AI Queue Management",
  "Smart Clinic Systems",
  "Hospital Token Systems",
  "Salon Queue Software",
  "AI Chatbots",
  "Business Automation",
  "Custom SaaS Platforms",
  "Mobile Apps",
  "Enterprise Websites",
];

export default function About() {
  return (
    <section id="about" className="section" data-testid="about-section">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="eyebrow mb-5">About — AIBoxHub</div>
            <h2 className="font-serif text-4xl md:text-5xl text-white tracking-tight leading-[1.05]">
              A premium studio for <span className="gold-text italic">applied AI</span> & digital infrastructure.
            </h2>
            <p className="mt-6 text-white/65 leading-relaxed">
              AIBoxHub is an international AI & software company. We design, build and operate the
              systems that quietly run modern businesses — from clinical queues and salon bookings to
              autonomous voice agents and enterprise SaaS platforms.
            </p>
            <div className="mt-8 grid grid-cols-2 gap-4">
              {[
                { Icon: Cpu, t: "Engineering" },
                { Icon: Workflow, t: "Automation" },
                { Icon: Boxes, t: "Productized SaaS" },
                { Icon: Building2, t: "Enterprise" },
              ].map(({ Icon, t }, i) => (
                <div key={i} className="glass-card p-5">
                  <Icon className="h-5 w-5 text-gold-400" strokeWidth={1.5} />
                  <div className="mt-3 font-serif text-lg text-white">{t}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="glass-card p-8 md:p-10">
              <div className="eyebrow text-white/40">What we build</div>
              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-6">
                {capabilities.map((c, i) => (
                  <div key={c} className="flex items-baseline gap-3 group" data-testid={`capability-${i}`}>
                    <span className="font-mono text-[10px] text-gold-500 tracking-widest">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-serif text-lg md:text-xl text-white/85 group-hover:text-gold-200 transition-colors">
                      {c}
                    </span>
                  </div>
                ))}
              </div>
              <div className="mt-10 divider-gold" />
              <p className="mt-6 text-sm text-white/55 leading-relaxed">
                Modular, multi-tenant, internationally deployable. Every module — from queue intelligence to
                marketplace, billing and analytics — is built to scale independently without architectural redesign.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
